// import React, { useEffect, useState } from 'react'
// import classes from "./ZipGameLeaderboard.module.css";
// import BottomNavbarZipGame from '../../components/ZipGame/BottomNavbarZipGame';
// import Header from '../../components/Header';
// import { FaArrowLeft, FaChessBoard, FaPlay, FaTrophy } from 'react-icons/fa6';
// import { useNavigate } from 'react-router-dom';
// import { zipGameLeaderboardApi } from '../../http/http';
// import { useSelector } from 'react-redux';

// const ZipGameLeaderboard = () => {

//     const navigate = useNavigate();

//     const { userZip } = useSelector(
//         (state) => state?.persisted?.userZipGameTokenSlice
//     );

//     const [leaderboard,setLeaderboard]=useState([]);

//     const [userRank,setUserRank]=useState([]);

//     const getInitials = (value) => {
//         const str = String(value || "User").trim();
//         const parts = str.split(/\s+/).filter(Boolean);

//         if (parts.length === 1) {
//             return parts[0].slice(0, 2).toUpperCase();
//         }

//         return (parts[0][0] + parts[1][0]).toUpperCase();
//     };

//     const leaderboardData = [
//         { id: 1, name: "Rahul", score: 2450 },
//         { id: 2, name: "Aman", score: 2210 },
//         { id: 3, name: "Sophia", score: 1980 },
//         { id: 4, name: "Daniel", score: 1760 },
//         { id: 5, name: "Neha", score: 1620 },
//     ];

//     const fetchLeaderboard = async () => {
//         try {
//             const response = await zipGameLeaderboardApi('', userZip?.token);
//             console.log(response.data,'response-');
//             setLeaderboard(response?.data?.result?.leaderboard);
//             setUserRank(response?.data?.result?.userRank);
//         } catch (error) {
//             console.log(error,'error-');
//         }
//     }

//     useEffect(() => {
//         fetchLeaderboard();
//     }, []);

//     return (
//         <>
//             <Header />

//             <div className={classes.page}>
//                 <div className={classes.container}>

//                     <div className={classes.header_section}>
//                         <button
//                             className={classes.back_button}
//                             onClick={() => navigate(-1)}
//                             type="button"
//                         >
//                             <FaArrowLeft className={classes.back_icon} />
//                         </button>

//                         <p className={classes.header_title}>Leaderboard</p>

//                     </div>

//                     <div className={classes.section_card}>
//                         <div className={classes.section_header}>
//                             <div className={classes.title_with_icon}>
//                                 <FaTrophy className={classes.trophy_icon} />
//                                 <p className={classes.section_title}>Leaderboard</p>
//                             </div>
//                             <span className={classes.leaderboard_badge}>Top Players (19-03-2026)</span>
//                         </div>

//                         <div className={classes.leaderboard_list}>
//                             {leaderboardData.map((player, index) => (
//                                 <div
//                                     key={player.id}
//                                     className={`${classes.leaderboard_item} ${index === 0 ? classes.first_rank : ""
//                                         }`}
//                                 >
//                                     <div className={classes.leaderboard_left}>
//                                         <div
//                                             className={`${classes.rank_badge} ${index === 0
//                                                 ? classes.rank_one
//                                                 : index === 1
//                                                     ? classes.rank_two
//                                                     : index === 2
//                                                         ? classes.rank_three
//                                                         : classes.rank_default
//                                                 }`}
//                                         >
//                                             #{index + 1}
//                                         </div>

//                                         <div className={classes.avatar_circle}>
//                                             {getInitials(player.name)}
//                                         </div>

//                                         <div className={classes.player_info}>
//                                             <p className={classes.player_name}>{player.name}</p>
//                                             <p className={classes.player_status}>Zip Master</p>
//                                         </div>
//                                     </div>

//                                     <div className={classes.score_box}>
//                                         <p className={classes.score_value}>{player.score}</p>
//                                         <p className={classes.score_label}>seconds</p>
//                                     </div>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             <BottomNavbarZipGame active={3} />
//         </>
//     )
// }

// export default ZipGameLeaderboard;


import React, { useEffect, useMemo, useState } from "react";
import classes from "./ZipGameLeaderboard.module.css";
import BottomNavbarZipGame from "../../components/ZipGame/BottomNavbarZipGame";
import Header from "../../components/Header";
import { FaArrowLeft, FaTrophy } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { zipGameLeaderboardApi } from "../../http/http";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const ZipGameLeaderboard = () => {
  const navigate = useNavigate();

  const {t}=useTranslation();

  const { userZip } = useSelector(
    (state) => state?.persisted?.userZipGameTokenSlice
  );

  const [leaderboard, setLeaderboard] = useState([]);
  const [userRank, setUserRank] = useState([]);
  const [loading, setLoading] = useState(true);

  const getInitials = (value) => {
    const str = String(value || "User").trim();
    const parts = str.split(/\s+/).filter(Boolean);

    if (parts.length === 1) {
      return parts[0].slice(0, 2).toUpperCase();
    }

    return (parts[0][0] + parts[1][0]).toUpperCase();
  };

  const formatTime = (totalSeconds) => {
    if (totalSeconds === null || totalSeconds === undefined) return "--";
    return `${totalSeconds}s`;
  };

  const formatPlayedDate = (dateString) => {
    if (!dateString) return t("142");

    const date = new Date(dateString.replace(" ", "T"));
    if (Number.isNaN(date.getTime())) return t("142");

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const maskMsisdn = (value) => {
    const str = String(value || "");
    if (!str) return "Unknown";
    if (str.length <= 2) return str;
    return `****${str.slice(-3)}`;
  };

  const formatPlayedAt = (dateString) => {
    if (!dateString) return "--";

    const date = new Date(dateString.replace(" ", "T"));
    if (Number.isNaN(date.getTime())) return dateString;

    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const fetchLeaderboard = async () => {
    try {
      setLoading(true);
      const response = await zipGameLeaderboardApi("", userZip?.token);

      setLeaderboard(response?.data?.result?.leaderboard || []);
      setUserRank(response?.data?.result?.userRank || []);
    } catch (error) {
      console.log(error, "error-");
      setLeaderboard([]);
      setUserRank([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaderboard();
  }, []);

  const myRank = useMemo(() => {
    if (userRank?.length > 0) return userRank[0];

    const foundInLeaderboard = leaderboard?.find(
      (item) => String(item?.msisdn) === String(userZip?.msisdn)
    );

    return foundInLeaderboard || null;
  }, [userRank, leaderboard, userZip?.msisdn]);

  const badgeDate = useMemo(() => {
    if (leaderboard?.length > 0) {
      return formatPlayedDate(leaderboard?.[0]?.played_at);
    }

    if (myRank?.played_at) {
      return formatPlayedDate(myRank?.played_at);
    }

    return "Today";
  }, [leaderboard, myRank]);

  return (
    <>
      <Header />

      {/* <div className={classes.page}> */}
      <div className={classes.container}>
        <div className={classes.header_section}>
          <button
            className={classes.back_button}
            onClick={() => navigate(-1)}
            type="button"
          >
            <FaArrowLeft className={classes.back_icon} />
          </button>

          <p className={classes.header_title}>{t("143")}</p>
        </div>

        {myRank && (
          <div className={classes.my_rank_card}>
            <div className={classes.my_rank_header}>
              <div className={classes.title_with_icon}>
                <FaTrophy className={classes.trophy_icon} />
                <p className={classes.section_title}>{t("144")}</p>
              </div>
              <span className={classes.you_badge}>{t("145")}</span>
            </div>

            <div className={classes.my_rank_content}>
              <div className={classes.leaderboard_left}>
                <div className={`${classes.rank_badge} ${classes.rank_one}`}>
                  #{myRank?.user_rank || "-"}
                </div>

                <div className={classes.avatar_circle}>
                  {myRank?.image ? (
                    <img
                      src={myRank.image}
                      alt={myRank?.name || "User"}
                      className={classes.avatar_image}
                    />
                  ) : (
                    getInitials(myRank?.name)
                  )}
                </div>

                <div className={classes.player_info}>
                  <p className={classes.player_name}>
                    {myRank?.name || "User"}
                  </p>
                  <p className={classes.player_status}>
                   {t("146")} {myRank?.moves ?? 0}
                  </p>
                </div>
              </div>

              <div className={classes.score_box}>
                <p className={classes.score_value}>
                  {formatTime(myRank?.total_time_seconds)}
                </p>
                <p className={classes.score_label}>{t("147")}</p>
              </div>
            </div>

            {/* <p className={classes.played_at_text}>
                Played at: {formatPlayedAt(myRank?.played_at)}
              </p> */}
          </div>
        )}

        <div className={classes.section_card}>
          <div className={classes.section_header}>
            <div className={classes.title_with_icon}>
              <FaTrophy className={classes.trophy_icon} />
              <p className={classes.section_title}>{t("143")}</p>
            </div>
            <span className={classes.leaderboard_badge}>{badgeDate}</span>
          </div>

          {loading ? (
            <div className={classes.state_card}>
              <p className={classes.state_text}>{t("148")}</p>
            </div>
          ) : leaderboard?.length > 0 ? (
            <div className={classes.leaderboard_list}>
              {leaderboard.map((player, index) => {
                const isCurrentUser =
                  String(player?.msisdn) === String(userZip?.msisdn);

                return (
                  <div
                    key={player?.game_trx_id || `${player?.msisdn}-${index}`}
                    className={`${classes.leaderboard_item} ${isCurrentUser ? classes.first_rank : ""}`}
                  >
                    <div className={classes.leaderboard_left}>
                      <div
                        className={`${classes.rank_badge} ${index === 0
                            ? classes.rank_one
                            : index === 1
                              ? classes.rank_two
                              : index === 2
                                ? classes.rank_three
                                : classes.rank_default
                          }`}
                      >
                        #{player?.user_rank || index + 1}
                      </div>

                      <div className={classes.avatar_circle}>
                        {player?.image ? (
                          <img
                            src={player.image}
                            alt={player?.name || "User"}
                            className={classes.avatar_image}
                          />
                        ) : (
                          getInitials(player?.name)
                        )}
                      </div>

                      <div className={classes.player_info}>
                        <p className={classes.player_name}>
                          {player?.name || "User"}
                        </p>
                        <p className={classes.player_name}>
                          {maskMsisdn(player?.msisdn)}
                        </p>
                        <p className={classes.player_status}>
                          {t("146")} {player?.moves ?? 0}
                          {isCurrentUser ? " • You" : ""}
                        </p>
                      </div>
                    </div>

                    <div className={classes.score_box}>
                      <p className={classes.score_value}>
                        {formatTime(player?.total_time_seconds)}
                      </p>
                      <p className={classes.score_label}>{t("147")}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className={classes.state_card}>
              <p className={classes.state_text}>
               {t("149")}
              </p>
            </div>
          )}
        </div>
      </div>
      {/* </div> */}

      <BottomNavbarZipGame active={3} />
    </>
  );
};

export default ZipGameLeaderboard;